export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_product_sets(state, {sets}) {
    state.product_sets = sets.data;
    state.totalCount = sets.total;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  },
  setFieldHandles(state, fieldHandles) {
    state.fieldHandles = fieldHandles.map(h => h.handle);
  }
};
